module.exports = __webpack_public_path__ + "img/watch_tp3-1.7dd6b25a.png";